import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, mergeProps as _mergeProps, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "flex items-center justify-center py-10" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createBlock($setup["TableRow"], null, {
        default: _withCtx(() => [
            _createVNode($setup["TableCell"], _mergeProps({
                class: $setup.cn('p-4 whitespace-nowrap align-middle text-sm text-foreground', $setup.props.class)
            }, $setup.delegatedProps), {
                default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_1, [
                        _renderSlot(_ctx.$slots, "default")
                    ])
                ]),
                _: 3 /* FORWARDED */
            }, 16 /* FULL_PROPS */, ["class"])
        ]),
        _: 3 /* FORWARDED */
    }));
}
